// extracted by mini-css-extract-plugin
module.exports = {"counts":"SpvAdminContributions_counts__2wpWJ","controls":"SpvAdminContributions_controls__1tfQb"};